import * as React from 'react';
import * as ReactDOM from 'react-dom';
import * as cls from 'classnames';
import { Route, Link, withRouter } from 'react-router-dom';
import Moment from 'react-moment';
import { AddReply } from './AddReply';
import * as Config from '../../../configuration/consts';

@withRouter
export class Reply extends React.Component<any, any> {
    formDispatch;
    constructor(props) {
        super(props);
        var showDetail = this.props.singlePostView || (this.props.item && this.props.item.active) ? true : false;
        
        this.state = { showLikes: false, showDetail: showDetail, confirmDelete: false, showMenu: false };
        
        this.onToggleClicked = this.onToggleClicked.bind(this);
        this.onMenuClicked = this.onMenuClicked.bind(this);
        this.onDeleteConfirmClicked = this.onDeleteConfirmClicked.bind(this);
        this.onDeleteClicked = this.onDeleteClicked.bind(this);
        this.onAddTagClicked = this.onAddTagClicked.bind(this);
        this.onLikeClicked = this.onLikeClicked.bind(this);
        this.onLikeToggleClicked = this.onLikeToggleClicked.bind(this);
    }
    onLikeClicked() {
        this.props.savePostReaction(this.props.forum.id, this.props.currentUser.id, this.props.item.id);
    }

    onLikeToggleClicked() {
        let showLikes = !this.state.showLikes;
        this.setState({ showLikes: showLikes });
    }

    onToggleClicked() {
        this.setState({ showDetail: !this.state.showDetail });
    }

    onMenuClicked() {
        this.setState({ showMenu: !this.state.showMenu });
    }

    onDeleteConfirmClicked() {
        this.setState({ confirmDelete: !this.state.confirmDelete});
    }

    onDeleteClicked(postId) {
        let post = this.props.forum.posts.find(i => i.id === postId)
        post.Obsolete = this.state.confirmDelete;
        this.props.savePost(this.props.forum.id, post);
    }

    onAddTagClicked(postId, tagId) {
        this.props.addPostTag(postId, tagId);
    }

    componentDidUpdate(prevProps, prevState) {
        if (prevProps != this.props) {
            this.setState({ showMenu: false, confirmDelete: false });
            // If the post is flagged as active then show detail
            var showDetail = this.props.item && this.props.item.active === true;
            if(showDetail && this.state.showDetail != showDetail){
                this.setState({showDetail: showDetail});
            }
        }
    }

    checkNestedLevel(parentId){
        /*Check the number of levels this reply is on... only allow for 3 atm */
        let level = 1;
        while (parentId){
           let parent = this.props.forum.posts.find(i => i.id === parentId);
            if(parent){
                parentId = parent.parentId;
            } else {
                parentId = undefined;
            }
            level++; 
        }
        return level;
    }

    render() {

        const { userRole, forum, currentUser, activeFilter, savePost, savePostReaction, singlePostView, ...props } = this.props;
            const { id, parentId, active, comment, forumMemberId, forumMemberName, creationDate, tags, resource, forumMemberAvatarId, link, file, reactions} = this.props.item;
            let isAdmin = userRole == Config.ROLE_ADMIN;

            let avatarImg = forumMemberAvatarId ? 
                                        `/api/attachment/${forumMemberAvatarId}` : 
                                        require("../../../assets/img/Unconfirmed.png");

            // Children Replies (recursive)
            let childReplies = this.state.showDetail ? forum.posts.map((i, index) => { 
                return (i.parentId === id) ? 
                    <Reply key={"rc" + index} userRole={userRole} item={i} 
                                forum={forum} currentUser={currentUser} activeFilter={activeFilter} 
                                savePost={savePost} savePostReaction={savePostReaction} singlePostView={singlePostView}/> : undefined}) : undefined;
            

            let children = forum.posts.filter(c => c.parentId === id);
            let childrenCount = !children ? 0 : children.length;

            let commentText = childrenCount == 0 ? "Reply" : childrenCount == 1 ? "1 Reply" : `${childrenCount} Replies`;
            let level = this.checkNestedLevel(parentId);
            let replyCss = level == 3 ? "discussion-board-reply" : undefined;

            // Split into component (this is a reply)
            let reply = this.state.showDetail && level < 3 ? <AddReply defaultSimpleMode={true} parentId={id} {...this.props}/> : undefined;
            let deleteAction = currentUser && (currentUser.id == forumMemberId || isAdmin) ? 
                                    <span>&nbsp;&sdot;&nbsp;<a className="clickable" onClick={this.onDeleteConfirmClicked}>Delete</a></span> : undefined;

            let deletePrompt = this.state.confirmDelete ? <div className="row">
                <div className="col-12 mt-2">
                        Are you sure you want to delete?
                        <a className="mx-1 btn btn-danger btn-small clickable" onClick={this.onDeleteClicked.bind(this, id)}>DELETE</a>
                        <a className="mx-1 btn btn-default btn-small clickable" onClick={this.onDeleteConfirmClicked} >CANCEL</a>
                </div>
            </div> : undefined;
            let deleteHighlight = this.state.confirmDelete ? "card-danger" : undefined;

            let likeDetail = this.state.showLikes ? reactions.map((item, index) => {
                return <span key={index}>{item.name}{index < reactions.length-1 ? "," : ""} </span>;
            }) : undefined;
            likeDetail = likeDetail && likeDetail.length > 0 ? <div className="text-muted small"><i className="fa fa-thumbs-up"></i> {likeDetail} </div> : undefined;
            let likeActive = reactions.find(i => i.forumMemberId == currentUser.id) != undefined;
            let likeText = likeActive ? <strong>Like</strong> : <span>Like</span>;
            let likeSummary = reactions && reactions.length > 0 ? <span onClick={this.onLikeToggleClicked}>&nbsp;&sdot;&nbsp;<i className={likeActive ? "fa fa-thumbs-up" : "fa fa-thumbs-o-up"}></i> {reactions.length}</span> : undefined;
            
            let replyAction = level < 3 ? <span>&nbsp;&sdot;&nbsp;<a className="clickable" onClick={this.onToggleClicked}>{commentText}</a></span> :undefined;
            
            let postActions = <span><a className="clickable" onClick={this.onLikeClicked}>{likeText}</a>
                                    {replyAction}{deleteAction}{likeSummary}{likeDetail}</span>;
            postActions = deletePrompt ? <div>{postActions} {deletePrompt}</div> : <div>{postActions}</div>;

            //let formattedComment = comment.replace("\n", "<br />").replace("\r", "<br />");
            return (<div className={`card py-2 ${replyCss} ${deleteHighlight}`}>
                <div className="row">
                    <div className="col-2 col-lg-1 pt-2 pr-0">
                        <div className="circle-avatar">
                            <img src={avatarImg} />
                        </div>
                    </div>
                    <div className="col-10 col-lg-11">
                        <div className="mb-2">
                            <div className="lightgrey-bg px-2 py-2">
                            
                            <div dangerouslySetInnerHTML={{ __html: comment }}></div>
                            <div className="text-muted small">{forumMemberName}&nbsp;&sdot;&nbsp;<Moment fromNow>{creationDate}</Moment></div>
                            </div>
                            {postActions}
                        </div>
                        {reply}
                        {childReplies}
                    </div>
                </div>
            </div>);
    }
}


// WEBPACK FOOTER //
// ./src/components/DiscussionBoard/Forum/Reply.tsx